"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlockLabelProps = void 0;
var getBlockLabelProps = function (props) {
    var blockLabelProps = [
        'id',
        'srNo',
        'label',
        'sublabel',
        'inputOnlyLabel',
        'readOnly',
        'errorMsgs',
        'error',
        'isRequired',
        'invert',
        'hints', // dummy commit for this
        "hintsBtnLabel",
        "hintsTitle",
        "hintsSubtitle",
        'hideOptionalLabel',
        'infoTooltip',
        'popOutOfOverflowHiddenParent',
        'disabled',
        'S'
    ];
    var labelProps = {};
    Object.keys(props).map(function (key) {
        if (blockLabelProps.includes(key)) {
            labelProps[key] = props[key];
        }
    });
    return labelProps;
};
exports.getBlockLabelProps = getBlockLabelProps;
